export default { describeTags: "7.5.6.11" };